<template>
  <vue-loading v-if="loading" :active.sync="loading" :is-full-page="true" loader="dots" color="#70A1F0"></vue-loading>
  <div v-else class="box">
    <div class="row">
      <div class="column col-margin">
        <div class="download">
          <button type="button" class="btn btn-sm btn-primary" v-on:click="downloadCSV">Download Report</button>
        </div>
        <h1 class="title-heading">Base2 Ops Tools Status</h1>
        <p class="description">Availability and Security incidents for base2 critical ops tools (OpenVPN and Elmer) over the last 12 months</p>
        <h2 class="status-heading">Availability</h2>
        <Uptime :data="availabilityData" @select="(payload) => { clickbar(payload) }"/>
        <h2 class="status-heading">Security</h2>
        <Uptime :data="securityData" @select="(payload) => { clickbar(payload) }"/>
      </div>
    </div>
    <transition name="slide">
      <div v-if="barSelected" class="pane">
        <div class="close-pane" v-on:click="closePane()">X</div>
        <h4>{{ selectedBar.month }} {{ selectedBar.year }}</h4>
        <div v-for="incident in selectedBar.incidents" :key="incident.date">
          <div class="incident-date">{{ incident.date }}</div>
          <div>{{ incident.description }}</div>
        </div>
        <div v-if="selectedBar.incidents.length == 0">
          <div class="no-incidents">No incidents</div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Uptime from '@/components/charts/Uptime'
import HTTP from '@/common/http'
import { mapGetters } from 'vuex'
import VueLoading from 'vue-loading-overlay'

export default {
  components: {
    VueLoading,
    Uptime
  },
  computed: {
    ...mapGetters([
      'settings'
    ]),
    barSelected () {
      return this.selectedBar !== null
    }
  },
  created: function () {
    this.getData()
  },
  methods: {
    clickbar: function (payload) {
      if (this.selectedBar === payload) {
        this.selectedBar = null
      } else {
        this.selectedBar = payload
      }
    },
    closePane: function () {
      this.selectedBar = null
    },
    getData: function () {
      this.loading = true
      HTTP.get(`opstools`)
        .then((response) => {
          this.availabilityData = response.data.opstools.availability
          this.securityData = response.data.opstools.security
        })
        .catch((error) => {
          this.flashMessage.error({
            message: `Failed to get OpsTools Report: ${error.message}`
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    downloadCSV: function () {
      this.flashMessage.info({
        message: 'Generating OpsTools CSV report',
        time: 3000
      })
      HTTP.get(`/opstools/csv`)
        .then((response) => {
          window.location = response.data.signedUrl
          this.flashMessage.success({
            message: 'OpsTools CSV report generation complete'
          })
        })
        .catch((error) => {
          this.flashMessage.error({
            message: `Failed to generate OpsTools CSV report : ${error.message}`
          })
        })
    }
  },
  data () {
    return {
      selectedBar: null,
      availabilityData: [],
      securityData: [],
      loading: true
    }
  }
}
</script>

<style>

.col-margin {
  margin-left: 14vw;
  margin-right: 14vw;
}

.download {
  padding-top: 7vh;
  padding-right: 0.5vw;
  float: right;
  cursor: pointer;
}

.title-heading {
  padding-top: 6vh;
  padding-left: 0.5vw;
  top: 6vh;
}

.description {
  padding-left: 0.8vw;
}

.status-heading {
  padding: 1vw;
  padding-top: 5vh;
}

.close-pane {
  position: absolute;
  font-size: larger;
  top: 100px;
  right: 8%;
  cursor: pointer;
}

.pane {
  position: absolute;
  right: 0px;
  padding-top: 100px;
  padding-bottom: 20vw;
  padding-left: 2vw;
  padding-right: 2vw;
  top: 0px;
  height: 100vh;
  width: 35vw;
  background-color: rgba(52,58,64,0.9);
  color: white;
}

.incident-date {
  padding-top: 20px;
  font-size:larger;
}

.no-incidents {
  padding-top: 20px;
}

.slide-leave-active,
.slide-enter-active {
  transition: 0.3s;
}
.slide-enter {
  transform: translate(100%, 0);
}
.slide-leave-to {
  transform: translate(100%, 0);
}

</style>



// WEBPACK FOOTER //
// src/views/OpsTools.vue